export default [
    {
        "year": 1985,
        "question": "矛盾的两种基本属性是（）",
        "A": "条件性和无条件性",
        "B": "普遍性和特殊性",
        "C": "绝对性和相对性",
        "D": "同一性和斗争性",
        "answer": "B"
    },
    {
        "year": 1986,
        "question": "矛盾的两种基本属性是（）",
        "A": "条件性和无条件性",
        "B": "普遍性和特殊性",
        "C": "绝对性和相对性",
        "D": "同一性和斗争性",
        "answer": "B"
    },
    {
        "year": 1987,
        "question": "矛盾的两种基本属性是（）",
        "A": "条件性和无条件性",
        "B": "普遍性和特殊性",
        "C": "绝对性和相对性",
        "D": "同一性和斗争性",
        "answer": "B"
    },
    {
        "year": 1988,
        "question": "矛盾的两种基本属性是（）",
        "A": "条件性和无条件性",
        "B": "普遍性和特殊性",
        "C": "绝对性和相对性",
        "D": "同一性和斗争性",
        "answer": "B"
    },
    {
        "year": 1989,
        "question": "联合国的五个常任理事国，除美国、苏联、英国、法国以外，还有（）",
        "A": "印度",
        "B": "波兰",
        "C": "中国",
        "D": "日本",
        "answer": "C"
    },
    {
        "year": 1990,
        "question": "我国的根本政治制度是（）",
        "A": "充分体现平等原则的普适制度",
        "B": "政治协商制度",
        "C": "人民代表大会制度",
        "D": "体现公民参加国家管理的民主监督制度",
        "answer": "C"
    },
    {
        "year": 1991,
        "question": "资本主义的议会制共和制和总统制共和制的共同点是（）",
        "A": "国家元首拥有实权",
        "B": "政府对议会负责",
        "C": "国家元首有权解散议会",
        "D": "国家元首由选举产生",
        "answer": "D"
    },
    {
        "year": 1992,
        "question": "一个政党在社会历史进程中是否起促进作用、取决于该政党是否（）",
        "A": "取得执政党地位",
        "B": "代表先进生产方式",
        "C": "维护无产阶级的利益",
        "D": "符合统治阶级的需要",
        "answer": "B"
    },
    {
        "year": 1993,
        "question": "全部马克思主义学说的核心和理论结论是（）",
        "A": "科学社会主义",
        "B": "辩证唯物主义",
        "C": "历史唯物主义",
        "D": "剩余价值学说",
        "answer": "B"
    },
    {
        "year": 1994,
        "question": "要全面贯彻中共十四届三中全会精神,保持国民经济持续、快速、健康发展，必须把握好（）三者之间的关系。",
        "A": "改革开放发展",
        "B": "开放发展稳定",
        "C": "改革开放稳定",
        "D": "改革发展稳定",
        "answer": "A"
    },
    {
        "year": 1995,
        "question": "唯物辩证法的否定之否定规律揭示了事物发展的（）",
        "A": "方向和道路",
        "B": "形式和状态",
        "C": "结构和功能",
        "D": "源泉和动力",
        "answer": "A"
    },
    {
        "year": 1996,
        "question": "区别新民主主义革命和旧民主主义革命的根本标志是（）",
        "A": "革命指导思想不同",
        "B": "革命领导权不同",
        "C": "革命前途不同",
        "D": "革命对象不同",
        "answer": "B"
    },
    {
        "year": 1997,
        "question": "恩格斯认为，全部哲学、特别是近代哲学的重大的基本问题是（）",
        "A": "哲学与人类生存活动之间的内在联系问题",
        "B": "人与周围世界的基本联系问题",
        "C": "思维和存在的关系问题",
        "D": "关于人的本质问题",
        "answer": "C"
    },
    {
        "year": 1998,
        "question": "恩格斯认为，全部哲学、特别是近代哲学的重大的基本问题是（）",
        "A": "哲学与人类生存活动之间的内在联系问题",
        "B": "人与周围世界的基本联系问题",
        "C": "思维和存在的关系问题",
        "D": "关于人的本质问题",
        "answer": "C"
    },
    {
        "year": 1999,
        "question": "中国政府将于对澳门恢复行使主权，被葡萄牙人占领了多年的澳门终于回到祖国的怀抱（）",
        "A": "1999年10月1日500",
        "B": "1999年12月20日400",
        "C": "1999年12月31日300",
        "D": "2000年1月1日200",
        "answer": "B"
    },
    {
        "year": 2000,
        "question": "我国国家机关中有权修改宪法的是（）",
        "A": "中国共产党全国代表大会",
        "B": "全国人民代表大会",
        "C": "全国人民代表大会常务委员会",
        "D": "国务院",
        "answer": "B"
    },
    {
        "year": 2001,
        "question": "人类创造的自然语言和人工语言（）",
        "A": "是人类的主观意识",
        "B": "既非物质，也非意识",
        "C": "是人类意识的物质外壳",
        "D": "是意识的客观内容",
        "answer": "D"
    },
    {
        "year": 2002,
        "question": "临北海和波罗的海、没有用欧元替代本国货币的欧盟国家是（）",
        "A": "瑞典",
        "B": "德国",
        "C": "丹麦",
        "D": "波兰",
        "answer": "A"
    },
    {
        "year": 2003,
        "question": "长江三角洲经济高速增长的根本原因是",
        "A": "市场机制比较成熟",
        "B": "特色经济形成规模",
        "C": "积极参与国际竞争",
        "D": "第一产业发展迅速",
        "answer": "B"
    },
    {
        "year": 2004,
        "question": "意境最充分的体现了（）",
        "A": "主观和客观的统一",
        "B": "形式和内容的统一",
        "C": "社会和个人的统一",
        "D": "继承和创新的统一",
        "answer": "A"
    },
    {
        "year": 2005,
        "question": "唯物辩证法认为，发展的实质是（）",
        "A": "矛盾双方的互相转化",
        "B": "新事物代替旧事物",
        "C": "前进性和曲折性的统一",
        "D": "量变到质变的过程",
        "answer": "C"
    },
    {
        "year": 2006,
        "question": "2005年6月,北京奥运会组委会公布的2008年奥运会主题口号是（）",
        "A": "新北京、新奥运",
        "B": "科技奥运、人文奥运、绿色奥运",
        "C": "同一个世界、同一个梦想",
        "D": "给北京一个机会，还世界一个奇迹",
        "answer": "C"
    },
    {
        "year": 2007,
        "question": "国务院决定从2006年起，每年6月的第二个星期六为中国的（）",
        "A": "物质文化遗产日",
        "B": "文化遗产日",
        "C": "非物质文化遗产日",
        "D": "文物保护日",
        "answer": "B"
    },
    {
        "year": 2008,
        "question": "调整存贷款基准利率表明中国人民银行（）",
        "A": "以银行利润为主要经营目标",
        "B": "是制定和实施货币政策的国家机关",
        "C": "是我国政府的组成部分",
        "D": "行使了宏观调控的行政手段",
        "answer": "D"
    },
    {
        "year": 2009,
        "question": "全国人民代表大会常务委员会是全国人民代表大会的（）",
        "A": "领导机关",
        "B": "常设机关",
        "C": "执行机关",
        "D": "监督机关",
        "answer": "B"
    },
    {
        "year": 2010,
        "question": "2009年11月，应中国国民党中央委员会的邀请，中共江苏省委书记梁保华率代表团访问台湾，并成功举办了“（）”活动。",
        "A": "苏台贸易文化论坛",
        "B": "台湾江苏节",
        "C": "两岸经贸合作论坛",
        "D": "台湾江苏周",
        "answer": "D"
    },
    {
        "year": 2011,
        "question": "2011年4月，十一届全国人大常委会将《中华人民共和国个人所得税法修正案(草案)》公布在中国人大网上，广泛征求群众意见。人大常委会实施该举措的根本原因是（）",
        "A": "我国是人民当家做主的国家",
        "B": "群众路线是我们党的根本领导方法",
        "C": "宪法规定公民享有监督权",
        "D": "政府建立了信息公开制度",
        "answer": "A"
    },
    {
        "year": 2012,
        "question": "十一届全国人大五次会议表决通过了一部重要法律的修改决定。这部法律是（）",
        "A": "身份证法",
        "B": "刑事诉讼法",
        "C": "著作权法",
        "D": "文物保护法",
        "answer": "B"
    },
    {
        "year": 2013,
        "question": "2012年11月，中国共产党第十八次全国代表大会在京举行。会议指出，解决“三农”问题的根本途径是（）",
        "A": "城乡发展一体化",
        "B": "推动科技创新",
        "C": "建设社会主义新农村",
        "D": "优化产业结构",
        "answer": "A"
    },
    {
        "year": 2014,
        "question": "要加大对民族省区的财政转移支付力度，关键是要增加财政收入。在我国当前情况下，增加财政收入的合理措施是（）",
        "A": "大幅度提高税率",
        "B": "大力发展实体经济",
        "C": "提高职工工资水平",
        "D": "扩大资本市场规模",
        "answer": "B"
    },
    {
        "year": 2015,
        "question": "1956年7月，印度、埃及和南斯拉夫共同发表直言，反对“把世界分为强有力的国家集团”。该直言（）",
        "A": "成为亚太经合组织的指导方针",
        "B": "奠定了不结盟运动的政治基础",
        "C": "推动丁北大西洋公约组织的成立",
        "D": "促成了国际货币基金组织的建立",
        "answer": "B"
    },
    {
        "year": 2016,
        "question": "发行国债是政府筹集资金的重要方式，这些债务最终是要偿还的。政府偿还国债的主要资金来源是（）",
        "A": "新国债的发行收入",
        "B": "国有企业上缴的利润",
        "C": "国债的投资收益",
        "D": "国家的税收收入",
        "answer": "D"
    },
    {
        "year": 2017,
        "question": "实施脱贫攻坚战略，开展精准扶贫精准脱贫（）",
        "A": "是发展成果由人民共享的必然要求",
        "B": "发挥了我国的政治优势和制度优势",
        "C": "优先维护了贫困人口的政治经济权利",
        "D": "是完善农村基层群众性组织的重要举措",
        "answer": "A"
    },
    {
        "year": 2018,
        "question": "随着智能手机的功能越来越强大，MP3 (音乐播放器)、电子词典、掌上游戏机等电子产品正慢慢淡出人们的视野。这说明（）",
        "A": "市场竞争导致商品优胜劣汰",
        "B": "商品使用价值会影响人的消费选择",
        "C": "功能不同的商品会相互替代",
        "D": "商品使用价值因替代品出现而减小",
        "answer": "A"
    },
    {
        "year": 2019,
        "question": "随着智能手机的功能越来越强大，MP3 (音乐播放器)、电子词典、掌上游戏机等电子产品正慢慢淡出人们的视野。这说明（）",
        "A": "市场竞争导致商品优胜劣汰",
        "B": "商品使用价值会影响人的消费选择",
        "C": "功能不同的商品会相互替代",
        "D": "商品使用价值因替代品出现而减小",
        "answer": "A"
    },
    {
        "year": 2020,
        "question": "随着智能手机的功能越来越强大，MP3 (音乐播放器)、电子词典、掌上游戏机等电子产品正慢慢淡出人们的视野。这说明（）",
        "A": "市场竞争导致商品优胜劣汰",
        "B": "商品使用价值会影响人的消费选择",
        "C": "功能不同的商品会相互替代",
        "D": "商品使用价值因替代品出现而减小",
        "answer": "A"
    }
]